<template>
  <div class="rj-page-card">
    <div class="rj-page-card__title">
      审批意见
    </div>
    <div class="rj-page-card__content">
      <el-form ref="rejectedForm" :model="rejectedForm" :rules="rules" class="demo-ruleForm">
        <div>
          <el-form-item prop="rejectedInfo">
            <el-input
              v-model="rejectedForm.rejectedInfo"
              type="textarea"
              placeholder="请输入您的驳回意见"
              maxlength="200"
              show-word-limit
              rows="3"
            />
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DismissedSuggestion',
  data () {
    return {
      rejectedForm: {
        rejectedInfo: ''
      },
      rules: {
        rejectedInfo: [
          { required: true, message: '请输入您的驳回意见', trigger: 'blur' }
        ]
      }

    };
  },
  props: {
    contractId: {
      type: [Number, String],
      default: 0
    }
  },
  methods: {
    // 验证表单
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs['rejectedForm'].validate((valid) => {
          if (valid) {
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    }
  }
};
</script>

<style lang="scss">

</style>
